
export const SS_URLS = {
    PIXELS: "wss://sss0.pixels.personaps.com/",
    PIXELS2: "wss://sss0.pixels2.personaps.com/",
    LLA100: "wss://lla100.pixels.personaps.com/",
    LLA10: "wss://lla10.pixels.personaps.com/",
};

/**
 * Gets the Signalling Server URL based on the ssOverride query parameter
 * @returns The Signalling Server URL to use
 */
export function getSignallingServerURL(joinTokenSSOverride?: string): string {
    // Check for ssOverride query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const ssOverride = joinTokenSSOverride ?? urlParams.get("ssOverride");

    if (ssOverride) {
        // Convert to uppercase to match the SS_URLS keys
        const urlKey = ssOverride.toUpperCase();

        if (urlKey in SS_URLS) {
            return SS_URLS[urlKey as keyof typeof SS_URLS];
        }
    }

    return import.meta.env.VITE_PIXEL_STREAMING_STREAMING_SERVER_URL || "";
}
